// Module
var code = "<template style=\"background-image:url(${imageUrl})\"> <require from=\"./modal-image.scss\"></require> <slot name=\"image-subtitle\"></slot> </template> ";
// Exports
module.exports = code;